<template>
  <v-layout column fill-height>
    <v-btn color="info" @click="$router.push('add-owner')">
      Add Owner
    </v-btn>
    <template v-for="owner in owners">
      <v-card :key="owner.id">
        <v-card-title class="title">
          {{ owner.email }}
        </v-card-title>
        <v-card-text>{{ owner.id }}</v-card-text>
      </v-card>
    </template>
  </v-layout>
</template>

<script>
import { db, getUid } from '@/plugins/firebase';

export default {
  name: 'Owners',
  data: () => ({
    owners: [],
  }),
  firestore: {
    owners: db
      .collection('users')
      .where('admin', '==', getUid())
      .where('accountType', '==', 'owner'),
  },
};
</script>

<style></style>
